<template>
  <div id="alarmPane" :style="styleObject" />
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import api from '../modules/api'
import L from '../modules/leaflet'

const PANE_ID = "alarm"
const PANE_LAYER = "alarm-layer"

function createAlarmPopup(alarm) {
  const opt = {
    closeButton: false,
    closeOnClick: false,
    minWidth: 30,
    maxWidth: 400,
    offset: L.point(0, 10),
    autoPan: false,
    className: 'alarm-popup-outter-tiny alarm-popup-outter-' + alarm.levelCode
  }

  const p = L.popup(opt)
    .setLatLng(L.latLng(alarm.latitude, alarm.longitude))
    .setContent(`<div class='alarm-popup text'>${alarm.type}</div>`)

  p.on('add', function() {
    var container = this._container;
    L.DomUtil.addClass(container, 'leaflet-clickable')

    L.DomEvent.on(container, 'click', (e) => {
      if (this.hasEventListeners(e.type)) {
        L.DomEvent.stopPropagation(e)
      }

      this.fire(e.type, {
        originalEvent: e,
        latlng: this.getLatLng()
      })
    })

    L.DomEvent
      .on(container, 'mouseover', function() {
        this._container.style.zIndex = 250
      }, this)
      .on(container, 'mouseout', function() {
        this._container.style.zIndex = 0
      }, this)
  })

  p.on('click', function() {
    p.bringToFront()
    if (this.getPopup()) {
      this.unbindPopup()
    }
    this.bindPopup(
      `<b>${alarm.title}</b><br/>${alarm.description}`,
      { offset: L.point(0, -30) }
    ).openPopup()
  })

  return p
}

export default {
  setup() {
    const store = useStore()
    const currentPaneId = computed(() => store.state.currentPaneId)

    const map = computed(() => store.state.map)

    return {
      currentPaneId,
      map
    }
  },

  computed: {
    styleObject() {
      return this.currentPaneId != PANE_ID ? { "display": "none" } : {}
    }
  },

  mounted() {
    this.init()
  },

  beforeUnmount() {
    this.clear()
  },

  methods: {
    getMap() {
      return this.$store.state.map
    },

    init() {
      console.log("    > loading pane .....", PANE_ID)
      api.fetchAlarm().then((alarms) => {
        const tinyMarkers = alarms.map((alarm) => createAlarmPopup(alarm))

        const layer = L.layerGroup(tinyMarkers)
        if (this.currentPaneId == PANE_ID) {
          this.getMap().addLayer(PANE_LAYER, layer)
        }
      })
    },

    clear() {
      console.log("    > closing pane .....", PANE_ID)
      const map = this.$store.state.map
      map.removeLayer(PANE_LAYER)
    }
  }
}

</script>

<style>

#alarmPane {
  z-index: 31; 
  width: 650px; 
  font-size: 10px;
  background-color: #fff!important;
  position: absolute!important;
  left: 50%!important;
  transform: translateX(-50%)!important;
  box-shadow: 0 1rem 3rem rgba(0,0,0,.175)!important;
  bottom:0;
  margin-bottom: .5rem!important;
}

.alarm-popup-outter-tiny .leaflet-popup-content-wrapper {padding: 0px; border-radius: 4px; }
.alarm-popup-outter-tiny .leaflet-popup-content{margin:1px; width:auto;}
.alarm-popup-outter-tiny .leaflet-popup-tip-container{display: none;}
.alarm-popup-outter-tiny .text {color: #fff; cursor:pointer;font-size:14px;padding:0px;margin:5px;}
.alarm-popup-outter-tiny .alarm-popup{text-align: center;}

.alarm-big .alarm-popup-outter-tiny .text {
  color: #fff;cursor:pointer;font-size:14px;padding:5px;margin:0px;}

.alarm-popup-outter-10 .leaflet-popup-content-wrapper {background-color: #497DF5;}
.alarm-popup-outter-20 .leaflet-popup-content-wrapper {background-color: #FFDE00;}
.alarm-popup-outter-20 .leaflet-popup-content .text {color: #000;}
.alarm-popup-outter-30 .leaflet-popup-content-wrapper {background-color: #FF9403;}
.alarm-popup-outter-40 .leaflet-popup-content-wrapper {background-color: #F23030;}
.alarm-popup-outter-50 .leaflet-popup-content-wrapper {background-color: #CCCCCC;}
.alarm-popup-outter-50 .leaflet-popup-content .text {color: #000;}

</style>